/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Icons } from "../../../components/icons";
import fetchData from "../../../utils/api";
import CartFooter from "./CartFooter";
import StripePayment from "./StripePayment";
import CartCustomerDetails from "./CartCustomerDetails";
import CardListItems from "./CardListItems";
import PlaceOrder from "../../place-order/PlaceOrder";
import RevolutPayment from "./RevolutPayment";
import { getI18n, useTranslation } from "react-i18next";
import { Card, CardContent } from "../../../components/ui/card";
import { Label } from "../../../components/ui/label";
import ErrorBoundary from "../../../ErrorBoundary";

export default function Cart({
  authToken,
  id,
  setCartTotal,
  restaurantDetail,
  setIsHeader,
  currentSelected,
  setCurrentSelected,
  isDineIn,
  selectedType,
  setSelectedType,
  ssoUserDetails,
  ssoAddress,
  handleSSOAddress,
  setRestaurantDetail,
  setIsTableReservation,
}) {
  const { t } = useTranslation();
  const [cartId, setCartId] = React.useState(localStorage.getItem("cart"));
  const [loading, setLoading] = React.useState<boolean>(true);
  const [cartList, setCartList] = React.useState<any>([]);
  const [subtotal, setSubTotal] = React.useState<number>(0);
  const [total, setTotal] = React.useState<number>(0);
  const [orderingMethod, setOrderingMethod] = React.useState("delivery");
  const [taxLabel, setTaxLabel] = React.useState<any>();
  const [serviceFeesLabel, setServiceFeesLabel] = React.useState<any>();
  const [isOnlinePayment, setIsOnlinePayment] = React.useState(false);
  const [isPlaceOrder, setIsPlaceOrder] = React.useState(false);
  const [paymentDetails, setPaymentDetails] = React.useState<any>(null);
  const [isCouponCode, setIsCouponCode] = React.useState(false);
  const [couponCode, setCouponCode] = React.useState(false);
  const [couponCodeValue, setCouponCodeValue] = React.useState("");
  const [isValidCoupon, setIsValidCoupon] = React.useState(false);
  const [couponData, setCouponData] = React.useState<any>(null);
  const [couponDiscount, setCouponDiscount] = React.useState<any>(null);
  const [deliveryFees, setDeliveryFees] = React.useState<any>(0);
  const [deliveryFeesTax, setDeliveryFeesTax] = React.useState<any>();
  const [minimumOrderAmount, setMinimumOrderAmount] = React.useState<any>(0);
  const [isTip, setIsTip] = React.useState<any>(false);
  const [tipAmount, setTipAmount] = React.useState<any>(0);
  const [totalTipAmount, setTotalTipAmount] = React.useState<any>(0);
  const [tipTaxFees, setTipTaxFees] = React.useState<any>(0);
  const [isCartNotFound, setIsCartNotFound] = React.useState(false);
  const [roundOff, setRoundOff] = React.useState<any>(0);
  const currentLanguage = getI18n().language;
  const handleCartList = async () => {
    const cachedCart = localStorage.getItem("cart");
    try {
      const body = { cart_id: cachedCart };
      const res = await fetchData({
        url: "cart/list",
        method: "POST",
        body,
        token: authToken,
      });

      if (res.status_code === 200 && res.message === "cart.not_found") {
        setIsCartNotFound(true);
        setLoading(false);
      }

      if (res.status_code !== 200) return;
      if (res.status_code === 200 && res.message === "cart.not_found") return;

      const restaurantDetail = await fetchData({
        url: "restaurant",
        method: "POST",
        token: authToken,
      });

      if (restaurantDetail.status_code === 200) {
        setRestaurantDetail(restaurantDetail.data);
      }

      const orderingMethod = res?.data?.cart?.orderingMethod?.ordering_method;
      setDeliveryFees(res?.data?.delivery_fees);
      setDeliveryFeesTax(res?.data?.delivery_fees_tax);
      setCartList(res.data.cart ?? []);
      setTotal(res?.data?.total);
      setRoundOff(res?.data?.round_off);
      setSubTotal(res?.data?.sub_total);
      setCouponCode(res.data.coupon);
      let coupon;
      if (res.data.cart.couponCode !== null) {
        coupon = res?.data?.coupon_code_discount;

        if (coupon) {
          setCouponDiscount(coupon);
          setIsValidCoupon(true);
        } else {
          setIsValidCoupon(false);
        }

        setCouponData(res.data.cart.couponDetails);
        setIsCouponCode(true);
        setCouponCodeValue(res.data.cart.couponCode);
      } else {
        setCouponData(null);
        setIsValidCoupon(false);
        setIsCouponCode(false);
        setCouponCodeValue("");
      }

      if (orderingMethod !== null || orderingMethod !== undefined) {
        setOrderingMethod(orderingMethod);
      }

      if (orderingMethod === "delivery") {
        setMinimumOrderAmount(res.data.minimum_order_amount);
      }

      if (res.data.cart?.details.length > 0) {
        setTaxLabel(res.data.tax_label);

        setServiceFeesLabel(res?.data?.service_fees_label);

        setTotal(parseFloat(res.data.total).toFixed(2) as unknown as number);
        setRoundOff(res?.data?.round_off);
      }
      setTipAmount(res.data.tip_amount ?? 0);

      setTotalTipAmount(res.data.total_tip_amount ?? 0);

      setTipTaxFees(res.data.tip_tax_fee ?? 0);

      setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  React.useEffect(() => {
    handleCartList();
  }, [selectedType]);

  React.useEffect(() => {
    if (isPlaceOrder) {
      const params = new URLSearchParams(window.location.search);
      const restaurantId = params.get("id");
      const newUrl = `/order-placed?${params.toString()}&cartId=${cartId}&authToken=${authToken}&langueage=${currentLanguage}`;
      window.location.href = newUrl;
    }
  }, [isPlaceOrder]);

  return (
    <div>
      {loading ? (
        <div className="h-[70dvh] flex justify-center items-center py-4 flex-col">
          <Icons.spinner className="size-5 animate-spin" />
          <h2>{t("please_wait")}</h2>
          <p className="text-sm mt-2 text-center">
            {t("order_history.did_you_know")}
          </p>
        </div>
      ) : (
        !isCartNotFound && (
          <div>
            {isOnlinePayment && paymentDetails ? (
              // <RevolutPayment
              //   email={paymentDetails.email}
              //   token={paymentDetails.token}
              //   cartId={cartId}
              //   id={id}
              //   authToken={authToken}
              //   setCurrentSelected={setCurrentSelected}
              //   setIsPlaceOrder={setIsPlaceOrder}
              //   restaurantDetail={restaurantDetail}
              //   setIsHeader={setIsHeader}
              //   cartList={cartList}
              //   setIsOnlinePayment={setIsOnlinePayment}
              // />
              <ErrorBoundary>
                <StripePayment
                  email={paymentDetails.email}
                  clientId={paymentDetails.clientId}
                  cartId={cartId}
                  id={id}
                  authToken={authToken}
                  setCurrentSelected={setCurrentSelected}
                  setIsPlaceOrder={setIsPlaceOrder}
                  restaurantDetail={restaurantDetail}
                  setIsHeader={setIsHeader}
                  setIsOnlinePayment={setIsOnlinePayment}
                  setCartTotal={setCartTotal}
                  total={total}
                  orderingMethod={orderingMethod}
                />
              </ErrorBoundary>
            ) : (
              // <StripePayment
              //   email={paymentDetails.email}
              //   clientId={paymentDetails.clientId}
              //   cartId={cartId}
              //   id={id}
              //   authToken={authToken}
              //   setCurrentSelected={setCurrentSelected}
              //   setIsPlaceOrder={setIsPlaceOrder}
              //   restaurantDetail={restaurantDetail}
              //   setIsHeader={setIsHeader}
              // />

              // isPlaceOrder ? (
              //   <ErrorBoundary>
              //     <PlaceOrder
              //       authToken={authToken}
              //       cartId={cartId}
              //       id={id}
              //       setIsPlaceOrder={setIsPlaceOrder}
              //       setCurrentSelected={setCurrentSelected}
              //       setIsHeader={setIsHeader}
              //       restaurantDetail={restaurantDetail}
              //       setIsTableReservation={setIsTableReservation}
              //       setCartTotal={setCartTotal}
              //     />
              //   </ErrorBoundary>
              // ) :
              <div className="container">
                <div className="grid lg:grid-cols-2 gap-4 md:gap-5">
                  <ErrorBoundary>
                    <CartCustomerDetails
                      cartList={cartList}
                      id={id}
                      authToken={authToken}
                      handleCartList={handleCartList}
                      orderingMethod={orderingMethod}
                      setOrderingMethod={setOrderingMethod}
                      restaurantDetail={restaurantDetail}
                      isDineIn={isDineIn}
                      selectedType={selectedType}
                      setSelectedType={setSelectedType}
                      ssoUserDetails={ssoUserDetails}
                      ssoAddress={ssoAddress}
                      handleSSOAddress={handleSSOAddress}
                    />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <CardListItems
                      authToken={authToken}
                      cartList={cartList}
                      couponCode={couponCode}
                      couponCodeValue={couponCodeValue}
                      couponData={couponData}
                      couponDiscount={couponDiscount}
                      handleCartList={handleCartList}
                      id={id}
                      isCouponCode={isCouponCode}
                      isValidCoupon={isValidCoupon}
                      orderingMethod={orderingMethod}
                      restaurantDetail={restaurantDetail}
                      setCartTotal={setCartTotal}
                      setCouponCodeValue={setCouponCodeValue}
                      setIsCouponCode={setIsCouponCode}
                      subtotal={subtotal}
                      taxLabel={taxLabel}
                      serviceFeesLabel={serviceFeesLabel}
                      total={total}
                      deliveryFeesTax={deliveryFeesTax}
                      deliveryFees={deliveryFees}
                      minimumOrderAmount={minimumOrderAmount}
                      cartId={cartId}
                      isOnlinePayment={isOnlinePayment}
                      paymentDetails={paymentDetails}
                      setIsHeader={setIsHeader}
                      setIsOnlinePayment={setIsOnlinePayment}
                      setIsPlaceOrder={setIsPlaceOrder}
                      setPaymentDetails={setPaymentDetails}
                      isTip={isTip}
                      setIsTip={setIsTip}
                      tipAmount={tipAmount}
                      setTipAmount={setTipAmount}
                      totalTipAmount={totalTipAmount}
                      tipTaxFees={tipTaxFees}
                      roundOff={roundOff}
                    />
                  </ErrorBoundary>
                </div>
              </div>
            )}
          </div>
        )
      )}
      {isCartNotFound && (
        <Card>
          <CardContent>
            <div className="flex justify-center">
              <Label>{t("cart.not_found")}</Label>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
